import { useSearchParams } from 'react-router-dom';
import { UnAuthorized } from './errorType';
import UnAuthorizedPage from './UnAuthorizedError';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const errorType = searchParams.get('type');

  return (
    (errorType === UnAuthorized) && <UnAuthorizedPage />
  );
};

export default ErrorPage;
